"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventVideoType = void 0;
var EventVideoType;
(function (EventVideoType) {
    EventVideoType["VirtualCeremony"] = "VirtualCeremony";
    EventVideoType["InPerson"] = "InPerson";
})(EventVideoType = exports.EventVideoType || (exports.EventVideoType = {}));
//# sourceMappingURL=event-video-type.js.map